export default () => {
    $(document).on('click', '.product-tabs-item-link', function(e) {
        e.preventDefault();

        const targetVal = $(this).attr('data-target');

        // Clean active
        $('.product-tabs-item-link').removeClass('active');
        $(this).addClass('active');

        // Toogle tabs
        $(`.product-tabs-tab`).removeClass('active');
        $(`.product-tabs-tab[data-target=${targetVal}]`).addClass('active');
    });
}